// Deterministic, seedable PRNG (mulberry32). The match stores the cursor in
// MatchState.rngState so shuffles are reproducible and fully server-authoritative.

export function nextRandom(state: number): { value: number; state: number } {
  let t = (state + 0x6d2b79f5) | 0;
  t = Math.imul(t ^ (t >>> 15), t | 1);
  t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
  const value = ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  return { value, state: t >>> 0 };
}

/** Fisher-Yates shuffle driven by the seedable RNG. Returns the shuffled array and the new cursor. */
export function shuffle<T>(items: T[], rngState: number): { items: T[]; rngState: number } {
  const result = [...items];
  let state = rngState;
  for (let i = result.length - 1; i > 0; i--) {
    const r = nextRandom(state);
    state = r.state;
    const j = Math.floor(r.value * (i + 1));
    [result[i], result[j]] = [result[j], result[i]];
  }
  return { items: result, rngState: state };
}

export function makeSeed(): number {
  return (Math.floor(Math.random() * 0xffffffff) >>> 0) || 1;
}
